var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.allocateFlights"),
        width: _vm.$selectByLang("350px", "390px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            "label-width": _vm.$selectByLang("60px", "100px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.Flight") } },
            [
              _c("el-input", {
                attrs: { no: "voyageFlight" },
                model: {
                  value: _vm.form.voyageFlight,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "voyageFlight", $$v)
                  },
                  expression: "form.voyageFlight"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.BookingProperty") } },
            [
              _c(
                "el-select",
                {
                  attrs: { no: "bookingTerm", clearable: false, size: "mini" },
                  model: {
                    value: _vm.form.bookingTerm,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "bookingTerm", $$v)
                    },
                    expression: "form.bookingTerm"
                  }
                },
                _vm._l(_vm.BOOKING_TERMS, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: _vm.isZh ? item.chineseName : item.englishName,
                      value: item.code
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "ETD" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  no: "etd",
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  clearable: ""
                },
                model: {
                  value: _vm.form.etd,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "etd", $$v)
                  },
                  expression: "form.etd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.route") } },
            [
              _c("cargo-user-select", {
                attrs: {
                  no: "planner",
                  "method-params": { category: "role", shape: "airline" },
                  "default-value": _vm.form.planner || ""
                },
                on: { change: _vm.onPlannerChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Payment.operation") } },
            [
              _c("cargo-user-select", {
                ref: "op",
                attrs: {
                  no: "op",
                  "method-params": {
                    category: "role",
                    shape: "aeop",
                    officeId:
                      _vm.$store.getters.currentOfficeId > 1
                        ? _vm.$store.getters.currentOfficeId
                        : null
                  },
                  "default-value": _vm.form.op || ""
                },
                on: { change: _vm.onOpChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.Documents") } },
            [
              _c("cargo-user-select", {
                attrs: {
                  no: "dc",
                  "method-params": { category: "role", shape: "doc" },
                  "default-value": _vm.form.dc || ""
                },
                on: { change: _vm.onDcChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Save", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }